import request from '@/utils/request';

export function createCard(data) {
    return request({ url: '/openapi/whiteboard/create', method: 'post', data });
}

export function listCard(data) {
    return request({ url: '/openapi/whiteboard/list', method: 'post', data });
}

export function likeCard(data) {
    return request({ url: '/openapi/whiteboard/like', method: 'post', data });
}

export function deleteCard(data) {
    return request({ url: '/whiteboard/delete', method: 'post', data });
}

export function sortCard(data) {
    return request({ url: '/whiteboard/sort', method: 'post', data });
}

export function topCard(data) {
    return request({ url: '/whiteboard/top', method: 'post', data });
}
